import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

type ReviewStatesContext = 'project' | 'accession' | 'deploy-system' | 'system';

@Component({
  selector: 'app-review-states',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-states.component.html',
  styleUrls: ['./review-states.component.scss'],
})
export class ReviewStatesComponent implements OnInit, OnChanges {
  @Input() context: ReviewStatesContext = 'project';
  @Input() stateGroups: { group: string; state: string }[] = [];
  @Input() dpd: boolean = false;
  @Input() idElement = '';
  @Input() showReviewButton = false;
  @Input() reviewButtonLabel = 'Revisar proyecto';
  @Input() onReview: (() => void) | null = null;
  @Input() activeStage: string | undefined;
  @Input() projectState: string | undefined;

  stateGroupNormalized: { groupKey: string; group: string; state: string }[] = [];

  textNormalize(group?: string | null): string {
    switch (group?.toLowerCase()) {
      case 'support':
        return 'Validación de grupo de apoyo';
      case 'reviewers':
        return 'Validación de revisores';
      case 'chief':
        return 'Validación de jefe de servicio';
      case 'dpd':
        return 'Validación de persona delegada de protección de datos';
      default:
        return group.toUpperCase();
    }
  }

  stateNormalize(state?: string | null): string {
    if (this.isProjectLikeContext()) {
      switch (state?.toLowerCase()) {
        case 'rejected':
          return 'RECHAZADA';
        case 'pending':
          return 'PENDIENTE DE APROBACIÓN ⚠️';
        case 'completed':
        case 'approved':
        case 'correction':
          return 'COMPLETO ✅';
        case 'waiting':
          return 'EN ESPERA ⏳';
        default:
          return 'ESTADO DESCONOCIDO';
      }
    } else {
      switch (state?.toLowerCase()) {
        case 'rejected':
          return 'RECHAZADA ❌';
        case 'pending':
        case 'waiting':
          return 'PENDIENTE ⚠️';
        case 'approved':
          return 'APROBADA ✅';
        case 'disabled':
          return 'BLOQUEADA';
        case 'blocked':
          return 'BLOQUEADA';
        case 'finished':
          return 'FINALIZADA';
        default:
          return 'ESTADO DESCONOCIDO';
      }
    }
  }

  processStateGroups(): void {
    const isCorrection = this.isProjectLikeContext() && this.projectState?.toLowerCase() === 'correction';

    if (isCorrection) {
      this.stateGroupNormalized = [
        {
          groupKey: 'chief',
          group: this.textNormalize('chief'),
          state: 'SOLICITA SUBSANACIÓN ❌',
        },
      ];
      return;
    }

    this.stateGroupNormalized = this.stateGroups.map((item) => ({
      groupKey: item.group,
      group: this.textNormalize(item.group),
      state: this.stateNormalize(item.state),
    }));
  }

  ngOnInit(): void {
    this.processStateGroups();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stateGroups'] || changes['context'] || changes['activeStage'] || changes['projectState']) {
      this.processStateGroups();
    }
  }

  shouldShowStageReviewButton(stageGroupKey: string): boolean {
    return this.context !== 'accession' && this.showReviewButton && stageGroupKey === this.activeStage;
  }

  private isProjectLikeContext(): boolean {
    return this.context === 'project' || this.context === 'deploy-system' || this.context === 'system';
  }
}
